import React from "react";
import "./Headline.sass";

interface HeadlineProps {
    level: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
    children: React.ReactNode;
    className?: string;
}

export function Headline({ level, className, children }: HeadlineProps) {
    return React.createElement(level, { className: className }, children);
}